import { createAuthUseCases } from '../application/createAuthUseCases';
import { supabaseAuthPort } from '../infrastructure/supabaseAuthPort';

export const authUseCases = createAuthUseCases(supabaseAuthPort);
